import { DefinedQueryObserverResult } from "@tanstack/react-query";
import {
  ApplicationStatus,
  Verification,
  VerificationStatus
} from "shared/types";
import { Applicant, Application } from "types/application";
import { CombinedIncomeProvider } from "./providers/CombinedIncomeProvider";
import { ReportContentSlice } from "./slices/ReportContentSlice";
import { ModalsSlice } from "./slices/ModalsSlice";
import { ReportHeaderSlice } from "./slices/ReportHeaderSlice";
import { RequestIncomeVerificationSlice } from "./slices/RequestIncomeVerificationSlice";

export const CombinedIncomeReportSlice = ({
  verificationId,
  applicantId,
  applicationId,
  hasCreditReport,
  applicant,
  applicationStatus,
  activeVerification,
  applicationMeta
}: {
  verificationId?: number;
  applicantId?: number;
  applicationId?: number;
  hasCreditReport?: boolean;
  applicant: Applicant;
  applicationStatus: ApplicationStatus;
  activeVerification: Verification;
  applicationMeta: DefinedQueryObserverResult<Application | undefined, unknown>;
}) => {
  const isPostCreatedVerification =
    Boolean(activeVerification.is_post_created) &&
    !activeVerification.archived_at &&
    applicationMeta.data?.status === ApplicationStatus.Submitted &&
    (
      [
        VerificationStatus.Pending,
        VerificationStatus.Canceled
      ] as VerificationStatus[]
    ).includes(activeVerification.status);

  return (
    <CombinedIncomeProvider
      verificationId={verificationId}
      applicantId={applicantId}
      applicationId={applicationId}
      hasCreditReport={hasCreditReport}
      applicant={applicant}
      applicationStatus={applicationStatus}
      activeVerification={activeVerification}
      applicationMeta={applicationMeta}
    >
      {isPostCreatedVerification ? (
        <RequestIncomeVerificationSlice />
      ) : (
        <>
          <ReportHeaderSlice />
          <ReportContentSlice />
        </>
      )}
      <ModalsSlice />
    </CombinedIncomeProvider>
  );
};
